import { Injectable, inject, signal } from '@angular/core';
import {
  BehaviorSubject,
  Observable,
  Subject,
  map,
  takeUntil,
  tap,
} from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { HomeDto } from '@shared/interfaces/dtos/home-dto.interface';
import { environment } from '../../../environments/environment.dev';

@Injectable({
  providedIn: 'root',
})
export class HomesService {
  private endPoint: string = 'homes';
  private http = inject(HttpClient);
  private baseUrl: string = environment.baseUrl;
  public destroyed$: Subject<void> = new Subject();
  public homes = signal<HomeDto[]>([]);
  public currentVisitedHome$ = new BehaviorSubject<HomeDto>({} as HomeDto);

  constructor() {
    const lastVistedHome = JSON.parse(localStorage.getItem('home') as string);
    if (lastVistedHome) {
      this.currentVisitedHome$.next(lastVistedHome);
    }
  }

  public fetchHomes(): Observable<HomeDto[]> {
    return this.http.get<HomeDto[]>(`${this.baseUrl}/${this.endPoint}`).pipe(
      takeUntil(this.destroyed$),
      tap((res: HomeDto[]) => {
        this.homes.set([...res]);
        return res;
      }),
      map((res: HomeDto[]) => {
        res.sort((a: HomeDto, b: HomeDto) => (a.name > b.name ? 1 : -1));
        return res;
      }),
    );
  }
}
